// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getVertexAI, getGenerativeModel } from "firebase/vertexai-preview";
const algoliasearch = require("algoliasearch");
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC_7Swxo-kDf80CeIsxS4e9jaZ6hfT_swE",
  authDomain: "trading-ai-d03b5.firebaseapp.com",
  projectId: "trading-ai-d03b5",
  storageBucket: "trading-ai-d03b5.appspot.com",
  messagingSenderId: "155363382130",
  appId: "1:155363382130:web:f31efe8d5db6f9c087c3eb",
  measurementId: "G-1YCMTHMCGS"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app, "gs://trading-ai-d03b5.appspot.com");
export const firestore = getFirestore(app)
export const searchClient = algoliasearch('GACYWIKE3B', '3e41441eb7e422e9565c8ade052bf9c3');

const vertexAI = getVertexAI(app, { location: "asia-northeast3" });
export const aiModel = getGenerativeModel(vertexAI, {
  model: "gemini-1.5-flash-001",
  generationConfig: {
    'maxOutputTokens': 1971,
    'topP': 0.95,
  },
  safetySettings: [
    {
      'category': 'HARM_CATEGORY_HATE_SPEECH',
      'threshold': 'BLOCK_MEDIUM_AND_ABOVE'
    },
    {
      'category': 'HARM_CATEGORY_DANGEROUS_CONTENT',
      'threshold': 'BLOCK_MEDIUM_AND_ABOVE'
    },
    {
      'category': 'HARM_CATEGORY_SEXUALLY_EXPLICIT',
      'threshold': 'BLOCK_MEDIUM_AND_ABOVE'
    },
    {
      'category': 'HARM_CATEGORY_HARASSMENT',
      'threshold': 'BLOCK_MEDIUM_AND_ABOVE'
    }
  ],
});
